export const TREE_PANEL_SIZES = {
  min: 20,
  max: 40,
} as const;

// thresholds per metrics master-group.
// metrics (in matching group) whom their deltas (value change) are outside of the group's threshold range are is considered bad
export type SimilarityThresholdType = Record<"execution" | "data", [number, number]>;

export const DEFAULT_SIMILARITY_THRESHOLD: SimilarityThresholdType = {
  execution: [-10, 0],
  data: [-2, 2],
};

export const MAP_GROUP_NAME_TO_MASTER_TYPE = {
  resources: "execution",
  time: "execution",
  schema: "data",
  distribution: "data",
  volume: "data",
};

import type { ToolboxConfig } from "src/components/App/components/AppToolboxSlot/AppToolboxSlot.types";

export const TOOLBOX_CONFIG: ToolboxConfig = {
  key: "comparativeAnalysis",
  initialValue: undefined,
  sections: [],
};
